import React, { useCallback } from 'react'
import PropTypes from 'prop-types'

import { TEMPLATES_MAP } from 'components/templates'
import { AVAILABLE_BRANDS } from 'styles/theme'
import { extractLayoutFromContent } from 'utils/layout'

import View from './view'
import { ErrorMessage } from 'components/atoms'

const defaultLayout = {
  color: AVAILABLE_BRANDS.ATH,
  layoutName: 'Layout1',
}

const ContentPresenter = ({ content, contentType, setContentTime }) => {
  const InvalidLayout = useCallback(() => <ErrorMessage title='Invalid layout' />)
  const layout = extractLayoutFromContent(content)

  const { layoutName, brand } = layout || defaultLayout

  const parsedLayoutName = layoutName.replace(/ /g, '')
  const parsedContentType = contentType.replace('-', '_')
  const Layout = TEMPLATES_MAP[parsedContentType]?.[parsedLayoutName]

  if (!Layout) {
    return <InvalidLayout />
  }

  return <View color={brand} content={content} Layout={Layout} setContentTime={setContentTime} />
}

ContentPresenter.defaultProps = {
  content: { attributes: {} },
  setContentTime: () => {},
}

ContentPresenter.propTypes = {
  content: PropTypes.object,
  contentType: PropTypes.string,
  setContentTime: PropTypes.func,
}

export default ContentPresenter
